import { connect } from 'react-redux';
import { mapStateToProps as mapDefaultStateToProps } from './TruckFormContainer';
import ShowTruckFormComponent from './ShowTruckFormComponent';
import { StoreState } from '../../store/state';

const mapStateToProps = (state: StoreState) => {
  const defaultStateProps = mapDefaultStateToProps(state);
  const customsBrokers = Object.values(state.customsBrokers.all)
    .map(({ id, name }) => ({ label: name, value: id })) || [];

  return {
    ...defaultStateProps,
    customsBrokers,
  };
};

export default connect(mapStateToProps)(ShowTruckFormComponent);
